import { Skeleton } from '@mui/material';

function SkeletonBox({ height = '45px' }) {
  return <Skeleton variant="rectangular" sx={{ height, mb: 0.5 }} />;
}

export default SkeletonBox;
